import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { fireSubscriptionSwitchTrackingEvent } from 'analytics';
import DateSelection from '../DateSelection';
import { SubscriptionAlert } from '../SubscriptionAlert';
import { SubscriptionModal } from '../SubscriptionModal';
import { setHasEndDate } from '../../state';
import { InfoText, SubTitle } from '../../../../styled';

const CoveragePeriod = ({ plans, minStartDate }) => {
  const dispatch = useDispatch();
  const { numberOfDays, hasEndDate } = useSelector(
    (state) => state.nomadInsurance.purchaseInsurance.coverage
  );

  const { data: planholder } = useSelector((state) => state.app.profile);
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);

  useEffect(() => {
    if (hasEndDate && numberOfDays > 28) {
      setShowSubscriptionModal(true);
    }
  }, [hasEndDate, numberOfDays]);

  return (
    <>
      <SubTitle>Coverage period</SubTitle>
      {hasEndDate ? (
        <InfoText>
          You must pay for your whole trip upfront when selecting set travel dates
          (minimum 5 days). If you are travelling more than 4 weeks, we recommend a
          subscription, which can be stopped at anytime.
        </InfoText>
      ) : (
        <InfoText>
          Your policy will auto-extend every 4 weeks (or 28 days) until you stop it, good
          for continuous travel around the world for up to 364 days.
        </InfoText>
      )}
      <DateSelection currentOffer={plans} minStartDate={minStartDate} />

      {hasEndDate && (
        <SubscriptionAlert
          switchToSubscription={() => {
            dispatch(setHasEndDate(false));
            fireSubscriptionSwitchTrackingEvent(planholder.userID);
          }}
        />
      )}
      <SubscriptionModal
        isOpen={showSubscriptionModal}
        onClose={() => setShowSubscriptionModal(false)}
        switchToSubscription={() => {
          dispatch(setHasEndDate(false));
          setShowSubscriptionModal(false);
          fireSubscriptionSwitchTrackingEvent(planholder.userID);
        }}
      />
    </>
  );
};

CoveragePeriod.propTypes = {
  plans: PropTypes.object,
  minStartDate: PropTypes.string
};

export default CoveragePeriod;
